export enum Path {
  TRAVEL = '/reise',
  OVERVIEW = '/skadesaker'
}

export const RebrandedPaths = [Path.TRAVEL];
